import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, Trash2 } from "lucide-react";
import { supabase } from "../../../lib/supabase";
import { deleteFromFtp } from "../../../lib/deleteFromFtp";

// Tipi şimdilik basit tutuyorum, types/News.ts'den de alabilirim ama hızlıca:
interface NewsItem {
  id: string;
  Title: string;
  Date: string;
  ContainerImagePath: string;
}

const NewsList: React.FC = () => {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [filteredNews, setFilteredNews] = useState<NewsItem[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
        const { data, error } = await supabase.from('news').select('*');
        if (error) {
            console.error(error);
        } else {
            setNews(data as NewsItem[]);
            setFilteredNews(data as NewsItem[]);
        }
        setLoading(false);
    };
    fetchNews();
  }, []);

  const handleDelete = async (id: string) => {
      if(!window.confirm("Bu haberi silmek istediğinize emin misiniz?")) return;
      
      const itemToDelete = news.find(n => n.id === id);

      try {
          const { error } = await supabase.from('news').delete().eq('id', id);
          if (!error) {
              if (itemToDelete?.ContainerImagePath) deleteFromFtp(itemToDelete.ContainerImagePath);
              const fetchNews = async () => {
                  const { data, error } = await supabase.from('news').select('*');
                  if (!error) {
                      setNews(data as NewsItem[]);
                      setFilteredNews(data as NewsItem[]);
                  }
              };
              fetchNews();
          } else {
              console.error(error);
          }
      } catch (error) {
          console.error(error);
      }
  }

  useEffect(() => {
    const results = news.filter((item) =>
      item.Title.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredNews(results);
  }, [search, news]);

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Haber Yönetimi</h1>
          <p className="text-gray-500">Tüm haberleri görüntüleyin ve düzenleyin</p>
        </div>
        <Link
          to="/panel/news/add"
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg flex items-center shadow-sm transition-all"
        >
          <Plus className="w-5 h-5 mr-2" />
          Yeni Haber Ekle
        </Link>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-4 border-b border-gray-100">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Haber ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {loading ? (
          <div className="p-8 text-center text-gray-500">Yükleniyor...</div>
        ) : filteredNews.length === 0 ? (
          <div className="p-8 text-center text-gray-500">Haber bulunamadı.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead className="bg-gray-50 text-gray-600 font-medium text-sm">
                <tr>
                  <th className="p-4">Görsel</th>
                  <th className="p-4">Başlık</th>
                  <th className="p-4">Tarih</th>
                  <th className="p-4">İşlem</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredNews.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                    <td className="p-4">
                      <div className="w-16 h-12 rounded bg-gray-200 overflow-hidden">
                         <img 
                           src={item.ContainerImagePath} 
                           alt={item.Title} 
                           className="w-full h-full object-cover"
                           onError={(e) => {(e.target as HTMLImageElement).src = '/logo.svg'}} 
                         />
                      </div>
                    </td>
                    <td className="p-4 font-medium text-gray-800">{item.Title}</td>
                    <td className="p-4 text-gray-500">{item.Date}</td>
                    <td className="p-4">
                        <button onClick={() => handleDelete(item.id)} className="text-red-500 hover:text-red-700">
                            <Trash2 size={20} />
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsList;
